import { TitleButton } from '@/common/buttons/TitleButton';
import { useDialog } from '@/common/dialog/DialogContext';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback } from 'react';

import { useParams } from 'react-router-dom';
import { PymtApprovalDialog } from './PymtApprovalDialog';

export const PymtList = ({ payeeCustId }) => {
  const { claimType } = useParams();
  const { openDialog } = useDialog();

  const augRowsReq = useCallback(
    (rowsReq) => {
      if (claimType) {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('claimType', claimType.toUpperCase()));
      }

      if (payeeCustId) {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('payeeCustId', payeeCustId));
      }
    },
    [claimType, payeeCustId],
  );

  const openPymtApprovalDialog = () => {
    openDialog(PymtApprovalDialog, { data: {} }).then((result) => {
      if (result?.submitted) {
        // Run data plugin to find and correct Pymt packages that have been routed incorrectly
      }
    });
  };

  const augButtons = (buttons) => {
    buttons.push(
      <TitleButton
        key="PymtApprovalButton"
        icon={fas.faUserCheck}
        toolTip="Configure Payment Approval Structure"
        onClick={openPymtApprovalDialog}
      />,
    );
  };

  return <EntityList module="sc" entity="PYMT" augRowsReq={augRowsReq} augButtons={augButtons} />;
};
